<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .col-12.mb-2
        h3.section-title.mt-0 {{ rrsName }}
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t("ui.member_id") }}
          DebounceInput(type="text" v-model="searchID" @enter="getRewardRainSessionClaimList(true)" size="sm")
      .form-group.col-md-9.col-10.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getRewardRainSessionClaimList(true)"
          variant="primary"
          size="sm"
        )

  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="9%" @click="sortOrder('member_id')")
                  span(:title="$t('ui.member_id')") {{ $t("ui.member_id") }}
                  .float-right
                    i(:class="changeSortKey('member_id')")
                th(width="8%" @click="sortOrder('client_ip')")
                  span(:title="$t('ui.ip')") {{ $t("ui.ip") }}
                  .float-right
                    i(:class="changeSortKey('client_ip')")
                th.text-right(width="8%" @click="sortOrder('reward_amount')")
                  span(:title="$t('ui.reward_amount')") {{ $t("ui.reward_amount") }}
                  .float-right
                    i(:class="changeSortKey('reward_amount')")
                th.text-right(width="8%" @click="sortOrder('created_at')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  .float-right
                    i(:class="changeSortKey('created_at')")
            tbody.clusterize-content
              tr(v-if="rewardRainSessionClaimList.length == 0")
                td(colspan="12").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in rewardRainSessionClaimList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.member_id") {{ item.member_id }}
                td
                  span(:title="item.client_ip") {{ item.client_ip }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.reward_amount)" :title="$n(item.reward_amount, 'currency')") {{ $n(item.reward_amount, 'currency') }}
                td.text-right
                  span(v-if="item.created_at" :title="$moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss') }}
              tr(v-if="showTotal")
                td.text-right(colspan="3")
                  span.d-block {{ $t("ui.sub_total") }}
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalAmount)" :title="$n(subTotalAmount, 'currency')") {{ $n(subTotalAmount, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmount)" :title="$n(grandTotalAmount, 'currency')") {{ $n(grandTotalAmount, 'currency') }}
                td

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    rrsId: {
      type: Number,
      default: ''
    },
    rrsName: {
      type: String,
      default: ""
    },
    operatorID: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    loading: false,
    rewardRainSessionClaimList: [],
    sortKey: "",
    sortType: "",
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    subTotalAmount: 0,
    grandTotalAmount: 0,
    showTotal: false,
    searchID: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeRewardRain;
    },
    loginId() {
      return this.$store.getters.loginId;
    },
  },
  mounted: function() { },
  methods: {
    refresh() {
      this.getRewardRainSessionClaimList(true)
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getRewardRainSessionClaimList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getRewardRainSessionClaimList: function(isSearch) {
      let url = config.rewardRainSessionClaimsUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        session_id: this.rrsId,
        member_id: this.searchID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearTotal()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.list && response.data.ds.list.length > 0) {
                  this.showTotal = true
                  this.rewardRainSessionClaimList = response.data.ds.list;
                  this.totalRow = this.rewardRainSessionClaimList.length > 0 ? this.rewardRainSessionClaimList[0].totalrows : 0;

                  response.data.ds.list.forEach(value => {
                    this.subTotalAmount = parseFloat(this.subTotalAmount) + parseFloat(value["reward_amount"]);
                  });
                  if(response.data.ds.grand_total.length > 0) {
                    this.grandTotalAmount = response.data.ds.grand_total[0]["total_claimed_amount"];
                  }
                } else {
                  this.clearTotal()
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearTotal() {
      this.showTotal = false
      this.rewardRainSessionClaimList = []
      this.totalRow = 0
      this.subTotalAmount = 0
      this.grandTotalAmount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeRewardRain", pageSize);
      this.currentPage = 1;
      this.getRewardRainSessionClaimList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getRewardRainSessionClaimList();
    }
  }
};
</script>